import CountUp from "react-countup";

const RevenueStats = ({ analyticsData }) => {
  const revenueStats = [
    {
      label: "Buyer Processing Fee",
      value: analyticsData?.total_buyer_processing_fee || 0,
    },
    {
      label: "Buyer Shipping Fee",
      value: analyticsData?.total_buyer_shipping_fee || 0,
    },
    {
      label: "Seller Shipping Fee",
      value: analyticsData?.total_seller_shipping_fee || 0,
    },
    {
      label: "Seller Processing Fee",
      value: analyticsData?.total_seller_processing_fee || 0,
    },
    {
      label: "Seller Transaction Fee",
      value: analyticsData?.total_seller_transaction_fee || 0,
    },
    {
      label: "Seller Penalty",
      value: analyticsData?.total_seller_penalty || 0,
    },
    {
      label: "Total Purchase",
      value: analyticsData?.total_purchase || 0,
    },
    {
      label: "Seller Payout",
      value: analyticsData?.total_seller_payout || 0,
    },
  ];

  return (
    <div className="dashboard-section">
      <h4 className="section-title mb-4">Revenue Analytics</h4>

      <div className="row g-4">
        {revenueStats.map((item, index) => (
          <div className="col-12 col-md-6 col-lg-3" key={index}>
            <div className="revenue-card">
              <p>{item.label}</p>

              <h5>
                $
                <CountUp
                  end={Number(item.value)}
                  duration={2}
                  separator=","
                  decimals={2}
                />
              </h5>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default RevenueStats;
